<script setup lang="ts">
/**
 * **Le disque d'attente** — un seul dessin pour tout ce qui « tourne ».
 *
 * Il était recopié dans `AppButton`, `AppIconButton` et une demi-douzaine de
 * vues, chacune avec son épaisseur et sa taille. Il prend la couleur du texte
 * (`currentColor`) et la taille que lui donne sa classe (`size-4` par défaut).
 *
 * Il est MUET par défaut (`aria-hidden`) : dans un bouton, l'attente est déjà
 * annoncée par `aria-busy`. Seul, il prend un nom (`label`) et devient un
 * `role="status"` — « Chargement… » se dit, un disque ne se voit pas.
 *
 * Le mouvement est coupé par `prefers-reduced-motion` (règle globale de
 * `theme.css`) : le disque reste alors immobile, à trois quarts ouvert, ce qui
 * se lit encore comme « en cours ».
 */
withDefaults(defineProps<{ label?: string | undefined }>(), { label: undefined });
</script>

<template>
  <span
    class="inline-flex size-4 shrink-0"
    :role="label === undefined ? undefined : 'status'"
    :aria-label="label"
    data-testid="spinner"
  >
    <svg class="size-full animate-spin" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="2" opacity="0.25" />
      <path
        d="M14.5 8A6.5 6.5 0 0 0 8 1.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </span>
</template>
